import { DataSource, HorizontalSpacer, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierAction extends Layout {
    horizontalspacer1: HorizontalSpacer;
    sourceCarrierAction: DataSource;
    textboxActionDate: Textbox;
    textboxActivityId: Textbox;
    textboxCarrierId: Textbox;
    textboxDateDue: Textbox;
    textboxDescr: Textbox;
    textboxEmail: Textbox;
    textboxNextActDate: Textbox;
    textboxNextActId: Textbox;
    textboxNextAction: Textbox;
    textboxObjection1Script: Textbox;
    textboxObjection2Script: Textbox;
    textboxObjectionId1: Textbox;
    textboxObjectionId2: Textbox;
    textboxOperationsUser: Textbox;
    textboxPhone: Textbox;
    textboxPrimaryContact: Textbox;
    textboxRemarks: Textbox;
    textboxSalespersonId: Textbox;
    textboxStatus: Textbox;
}
